/** 수정 연필 아이콘 — ui-core 에 공용 아이콘이 없어 InlineEditField 와 같은 모양으로 둔다. 색은 currentColor. */
export function EditPencilIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false">
      <path d="M17 3a2.85 2.85 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5z" />
    </svg>
  )
}
